// extracted by mini-css-extract-plugin
export default {"descriptionList":"About-descriptionList-Ubr6l DescriptionList-descriptionList-o7bt3"};